import { GridFilterModel } from '@mui/x-data-grid-premium';

export const saveToSessionStorage = <T>(key: string, value: T): void => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // quota exceeded or unavailable
  }
};

export const getFromSessionStorage = <T>(key: string): T | null => {
  try {
    const item = sessionStorage.getItem(key);
    return item ? (JSON.parse(item) as T) : null;
  } catch {
    return null;
  }
};

/** Shared by all Kjedeadmin DataGrid tables via {@link saveFilterModelToSessionStorage}. */
export const DATA_GRID_FILTER_MODEL_STORAGE_PREFIX = 'data-grid-filter-model-';

const getFilterModelStorageKey = (tableId: string): string =>
  `${DATA_GRID_FILTER_MODEL_STORAGE_PREFIX}${tableId}`;

export const saveFilterModelToSessionStorage = (
  tableId: string,
  filterModel: GridFilterModel
): void => saveToSessionStorage(getFilterModelStorageKey(tableId), filterModel);

export const getFilterModelFromSessionStorage = (tableId: string): GridFilterModel | null =>
  getFromSessionStorage<GridFilterModel>(getFilterModelStorageKey(tableId));

export const clearFilterModelFromSessionStorage = (tableId: string): void => {
  try {
    const baseKey = getFilterModelStorageKey(tableId);
    sessionStorage.removeItem(baseKey);
    const scopedPrefix = `${baseKey}--`;
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (key?.startsWith(scopedPrefix)) {
        sessionStorage.removeItem(key);
      }
    }
  } catch {
    // unavailable
  }
};

/** Clears every DataGrid quick-filter saved by Kjedeadmin (e.g. on brand switch). */
export const clearBrandTableFiltersFromSessionStorage = (): void => {
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (key?.startsWith(DATA_GRID_FILTER_MODEL_STORAGE_PREFIX)) {
        sessionStorage.removeItem(key);
      }
    }
  } catch {
    // unavailable
  }
};
